import React from 'react'
import Icon from '../AppIcon'

/** Page-level sections stay in a compact row; primary navigation owns the sidebar. */
export default function OfficeWorkspaceShell({
  activeSectionId, activeSectionLabel, operations = [], workspaces = [],
  operationsTitle = 'Operations', workspacesTitle = 'Workspaces', rightPanel = null, children,
}) {
  const renderNavigation = (items, title) => items.length > 0 && <nav aria-label={title} className="mb-6 flex min-w-0 gap-1 overflow-x-auto border-b border-border">
    {items.map(item => <button type="button" key={item.id} onClick={() => item.onClick?.()}
      aria-current={activeSectionId === item.id ? 'page' : undefined}
      className={'relative flex min-h-12 shrink-0 items-center gap-2 whitespace-nowrap border-b-2 px-3 text-xs font-medium transition-colors ' +
        (activeSectionId === item.id ? 'border-foreground text-foreground' : 'border-transparent text-muted-foreground hover:border-border hover:text-foreground')}>
      <Icon name={item.icon || 'LayoutDashboard'} size={15} /><span>{item.label}</span>
    </button>)}
  </nav>
  return <div className="min-w-0">
    {renderNavigation(operations, operationsTitle)}
    {renderNavigation(workspaces, workspacesTitle)}
    <div className={rightPanel ? 'grid min-w-0 grid-cols-1 gap-6 xl:grid-cols-[minmax(0,1fr)_340px]' : 'min-w-0'}>
      <section aria-label={activeSectionLabel} className="min-w-0">{children}</section>
      {rightPanel && <aside className="min-w-0"><div className="xl:sticky xl:top-24">{rightPanel}</div></aside>}
    </div>
  </div>
}
